// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
function ProductCardHoverImage(Props) {
  var src = Props.src;
  var fit = Props.fit;
  var alt = Props.alt;
  var priority = Props.priority;
  var onImageRendered = Props.onImageRendered;
  var enabled = Props.enabled;
  var match = React.useState(function () {
    return false;
  });
  var setIsLoaded = match[1];
  React.useEffect(function () {
    Curry._1(setIsLoaded, function (param) {
      return false;
    });
  }, [src]);
  var handleOnLoad = function ($$event) {
    Curry._1(setIsLoaded, function (param) {
      if ($$event.imageSize.width >= $$event.width) {
        return $$event.imageSize.height >= $$event.height;
      } else {
        return false;
      }
    });
  };
  var backgroundCn = match[0] ? "bg-placeholder" : "";
  var tmp = {
    src: src,
    fit: fit,
    alt: alt,
    priority: priority,
    onLoad: handleOnLoad
  };
  if (onImageRendered !== undefined) {
    tmp.onRender = Caml_option.valFromOption(onImageRendered);
  }
  return React.createElement(ConditionalRender$Showside.When.make, {
    condition: enabled,
    children: React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["transition-opacity duration-300 absolute inset-0 flex items-center justify-center", "group-2-hover:opacity-100 opacity-0", backgroundCn]))
    }, React.createElement(SmartImg$Showside.make, tmp))
  });
}
ProductCardHoverImage.displayName = "ProductCardHoverImage";
var make = ProductCardHoverImage;
export { make };
/* react Not a pure module */